<template>
  <div style="position: relative">
    <v-container v-if="isLoading" class="center-container">
      <div style="width: 100%">
        <LoadingComponent></LoadingComponent>
      </div>
    </v-container>
    <GeneratedComponent
      ref="generatedComponentRef"
      v-show="!isLoading && !isError"
      @loading="handleLoading"
      @error="handleError"
    ></GeneratedComponent>

    <v-container v-show="!isLoading && isError">
      <ErrorGenerate
        @retry="handleReload"
        :title="errorTitle"
        :message="errorMessage"
        :show-retry="true"
      ></ErrorGenerate>
    </v-container>
  </div>
</template>

<script setup>
import { defineEmits } from "vue";
import LoadingComponent from "@/components/LoadingComponent.vue";
import GeneratedComponent from "@/components/GeneratedComponent.vue";
import { ref, onMounted } from "vue";
import ErrorGenerate from "@/components/ErrorGenerate.vue";

const isLoading = ref(false);
const isError = ref(false);
const errorTitle = ref("");
const errorMessage = ref("");
const emit = defineEmits(["change-header-footer", "fetch-data"]);
const generatedComponentRef = ref(null);

const handleLoading = (isLoadingValue) => {
  console.log("isLoadingValue", isLoadingValue);
  isLoading.value = isLoadingValue;
};

const handleError = (errorData) => {
  console.log("LessonPackagePage handleError", errorData);

  // If GeneratedComponent sends error data, use it for the error display
  if (errorData && typeof errorData === "object") {
    isError.value = true;
    errorTitle.value = errorData.title || "Error occurred";
    errorMessage.value = errorData.message || "An unexpected error occurred";
  } else {
    // Fallback for simple error emission
    isError.value = true;
    errorTitle.value = "Error occurred";
    errorMessage.value = "An unexpected error occurred";
  }
};

const handleReload = () => {
  // Reset error state
  isError.value = false;
  errorTitle.value = "";
  errorMessage.value = "";

  // Trigger retry in GeneratedComponent
  if (generatedComponentRef.value) {
    generatedComponentRef.value.handleRetry();
  }
};

onMounted(() => {
  // const route = useRoute();
  // const lessonPackageId = route.params.id;
  // console.log("ID Lesson Package:", lessonPackageId);
  emit("handleChangeFooterType", "simplified-footer");
});
</script>
